<template>
  <div class="shareTipContainer" v-show="show" @click="hideTip">
    <img
      :src="imgUrl"
      :style="{
        width: remChange(width),
        top: remChange(top),
        right: remChange(right)
      }"
    />
  </div>
</template>

<script>
/**
 * 使用方法
 * shareTip({
      width: auto, // 图片宽度
      top: 0px, // 图片距离顶部距离
      right: 0px, // 图片距离右边距离
      body: document.body //需要挂载到的位置
    });
 */
export default {
  name: 'shareTip',
  props: ['imgUrl', 'width', 'top', 'right', 'duration', 'close'],
  data() {
    return {
      show: true
    };
  },
  filters: {},
  created() {
    if (this.duration && typeof this.duration == 'number') {
      let timer = setTimeout(() => {
        this.show = false;
        clearTimeout(timer);
      }, this.duration);
    }
  },
  methods: {
    remChange(value) {
      return value ? parseInt(value) / 75 + 'rem' : value;
    },
    hideTip() {
      this.show = false;
      if (this.close && typeof this.close == 'function') {
        this.close();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.shareTipContainer {
  position: fixed;
  top: 0px;
  width: 100%;
  height: 100%;
  left: 0px;
  z-index: 11;
  img {
    position: absolute;
    width: 580px;
    max-width: 750px;
    z-index: 13;
    top: 0px;
    right: 0px;
  }
  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    z-index: 12;
    background: rgba(0, 0, 0, 1);
    opacity: 0.5;
  }
}
</style>
